import { Button, Flex, Typography, UploadFile } from "antd";
import UploadXlsxDragger from "./UploadCsvDragger";
import { useState } from "react";
import UploadJobTable from "./UploadJobTable";
import { useCreateDistributorInventoryUploadMutation } from "../../../api/admin/distributors/distributorsApi";

const TEMPLATE_FILE_URL = "/generic-esim-inventory-template.csv"

export default function InventoryUploadPage() {
  // Should only have 0-1 files at any time
  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const [isUploading, setIsUploading] = useState(false);
  const [createDistributorUpload] = useCreateDistributorInventoryUploadMutation();

  async function handleUpload() {
    setIsUploading(true);
    try {
      setIsUploading(true);
      const file = fileList[0] as unknown as File;
      const upload = await createDistributorUpload({ filename: file.name }).unwrap();
      const response = await fetch(upload.uploadUrl, {
        method: "PUT",
        body: file,
      });
      if (!response.ok) {
        throw new Error("Failed to upload inventory file");
      }
      setTimeout(() => {
        alert("File uploaded successfully. Please refresh to view changes");
        setIsUploading(false);
        window.location.reload();
      }, 2000);
    } catch (error) {
      console.error("Error uploading file:", error);
      alert("Failed to upload file. Please try again.");
      setIsUploading(false);
    } finally {
      setFileList([]); // Clear the file list after upload
    }
  }

  function handleDlTemplate() {
    window.open(TEMPLATE_FILE_URL, "_blank");
  }

  return (
    <Flex vertical gap={8}>
      <Typography.Title level={2}>Upload Inventory</Typography.Title>
      <Button type="primary" onClick={handleDlTemplate}>
        Download Template File
      </Button>
      <UploadXlsxDragger fileList={fileList} setFileList={setFileList} />
      <Flex justify="flex-end">
        <Button
          type="primary"
          onClick={handleUpload}
          disabled={fileList.length === 0 || isUploading}
        >
          Upload
        </Button>
      </Flex>
      <UploadJobTable />
    </Flex>
  )
}
